(function(){
  const ready = (fn)=> document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);

  ready(() => {
    const bar = document.querySelector('[data-ip-sticky-atc]');
    if(!bar) return;

   const btnCart = bar.querySelector('[data-ip-sticky-btn-cart]');
const btnBuy  = bar.querySelector('[data-ip-sticky-btn-buy]');
    const priceEl = bar.querySelector('[data-ip-sticky-price]');

const form =
  document.querySelector('form[action^="/cart/add"]') ||
  document.querySelector('form[action*="cart/add"]') ||
  document.querySelector('form[data-product-form]') ||
  document.querySelector('form[id*="product-form"]');

const getVariantId = () => {
  // Most reliable: hidden input Shopify uses for selected variant
  const input =
    (form && form.querySelector('input[name="id"]')) ||
    document.querySelector('input[name="id"]');

  if (input && input.value) return input.value;

  // Fallback: some themes use a select[name="id"]
  const sel =
    (form && form.querySelector('select[name="id"]')) ||
    document.querySelector('select[name="id"]');

  return sel && sel.value ? sel.value : null;
};

const mainButton =
  (form && (form.querySelector('button[type="submit"]') || form.querySelector('[type="submit"]'))) ||
  document.querySelector('button[type="submit"][name="add"]') ||
  document.querySelector('button[type="submit"][data-add-to-cart]');

    const showLogic = () => {
      if(!mainButton){ bar.classList.add('is-visible'); return; }
      const rect = mainButton.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);

      // prevent covering page content
      document.documentElement.style.setProperty('--ip-sticky-h', bar.offsetHeight + 'px');
      document.body.style.paddingBottom = bar.classList.contains('is-visible') ? 'var(--ip-sticky-h)' : '';
    };

    window.addEventListener('scroll', showLogic, { passive:true });
    window.addEventListener('resize', showLogic, { passive:true });
    showLogic();

    // sync displayed price (simple DOM mirror)
    let last = getVariantId();
    setInterval(() => {
      const v = getVariantId();
      if(v && v !== last){
        last = v;
        const mainPrice = document.querySelector('[data-price]') || document.querySelector('.price') || document.querySelector('[class*="price"]');
        if(mainPrice && priceEl) priceEl.textContent = mainPrice.textContent.trim();
      }
    }, 400);

    const addToCart = async (variantId) => {
      const res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ id:Number(variantId), quantity: 1 })
      });
      if(!res.ok) throw new Error('Add to cart failed');
      return res.json();
    };

   const handle = async (mode) => {
  const id = getVariantId();
  if(!id) return;

  const btn = (mode === 'buy') ? btnBuy : btnCart;
  if(!btn) return;

  btn.disabled = true;
  const original = btn.textContent;
  btn.textContent = (mode === 'buy') ? 'Redirection…' : 'Ajout…';

  try{
    await addToCart(id);

    if(mode === 'buy'){
      // Add then go to checkout
      window.location.assign('/checkout?ts=' + Date.now());
      return;
    }

    // Add then go to cart (fresh render)
    btn.textContent = 'Ajouté ✓';
    window.location.assign('/cart?ts=' + Date.now());

  }catch(e){
    btn.textContent = 'Erreur';
    setTimeout(()=> btn.textContent = original, 1200);
  }finally{
    btn.disabled = false;
  }
};

btnCart && btnCart.addEventListener('click', () => handle('cart'));
btnBuy  && btnBuy.addEventListener('click',  () => handle('buy'));
  });
})();